
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IUserModel } from "@/api/types";
import { queryDetail } from "@/api/shipping-order";

@Component({
  name: "ShippingOrderDetailDialog",
})
export default class extends Vue {
  @Prop({ default: false }) private visible!: boolean;
  @Prop({ default: "" }) private shippingOrderId!: string;
  @Prop({ default: "" }) private shippingCode!: string;
  @Prop({ default: () => [] }) private sellerList!: IUserModel[];

  private dialogVisible = false;
  private loading = false;
  private detail: any = {};

  private internationalTradeTermsOptions = [
    { label: "FOB", value: "1" },
    { label: "CIF", value: "2" },
    { label: "CNF", value: "3" },
    { label: "DPU", value: "4" },
  ];

  private paymentOptions = [
    { label: "定金", value: "1" },
    { label: "赊账付款(OA)", value: "2" },
    { label: "信用证(L/C)", value: "3" },
    { label: "付款交单(DP)", value: "4" },
    { label: "发货前付款", value: "5" },
    { label: "见提单付款", value: "6" },
    { label: "其它", value: "7" },
  ];

  get displayShippingCode() {
    return this.shippingCode || this.detail.shippingCode || "";
  }

  get customerTag() {
    const code = this.detail.code || this.detail.customerCode || "";
    const abbr = this.detail.abbreviation || this.detail.customerAbbr || "";
    if (!code && !abbr) return "";
    return `${code} ${abbr}`.trim();
  }

  get sellerDisplay() {
    const seller = this.detail.seller;
    if (!seller) return "";
    const found = this.sellerList.find((item) => item.id === seller);
    if (!found) return String(seller);
    return found.code ? `${found.name} (${found.code})` : found.name;
  }

  get markTags() {
    const mark = this.detail.shippingMark;
    if (!mark) return [];
    return String(mark)
      .split(/[；;]/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  get tradeTermsLabel() {
    const value = this.detail.internationalTradeTerms;
    if (!value) return "";
    const found = this.internationalTradeTermsOptions.find(
      (item) => item.value === String(value)
    );
    return found ? found.label : value;
  }

  get paymentLabel() {
    const value = this.detail.payment;
    if (!value) return "";
    const found = this.paymentOptions.find(
      (item) => item.value === String(value)
    );
    return found ? found.label : value;
  }

  @Watch("visible", { immediate: true })
  private async onVisibleChange(val: boolean) {
    this.dialogVisible = val;
    if (val && this.shippingOrderId) {
      await this.loadDetail();
    }
    if (!val) {
      this.detail = {};
    }
  }

  @Watch("shippingOrderId")
  private async onShippingOrderIdChange(val: string) {
    if (this.dialogVisible && val) {
      await this.loadDetail();
    }
  }

  private async loadDetail() {
    this.loading = true;
    try {
      const data: any = await queryDetail(this.shippingOrderId);
      this.detail = {
        ...data,
        code: data.customerCode || data.code,
        abbreviation: data.customerAbbr || data.abbreviation,
        name: data.blName || data.name,
        address: data.blAddress || data.address,
        tel: data.blOtherInfo || data.tel,
      };
    } catch (e) {
      console.error(e);
      this.detail = {};
    } finally {
      this.loading = false;
    }
  }

  private handleClose() {
    this.$emit("update:visible", false);
  }
}
